export default {
  searchByQueryErrorResponse: 'There was a problem completing the search. Please try again.',
  getCurrentHotelAccommodationProducts:
    'There was a problem loading the accommodation products for this hotel. Please reload the page to try again.',
  offersListDeleteError: 'There was a problem deleting the offers. Please refresh this page and try again.',
};
